import React from 'react';

import { Router } from './app-routing';
import ErrorBoundary from '@/components/errorBoundary';

import render from '@/entrys/index';

const Index: React.FC = () => {
  return (
    <ErrorBoundary>
      <Router />
    </ErrorBoundary>
  );
};
render(<Index />);
